module.exports = __webpack_public_path__ + "static/media/Icon_Menu_Black.be13c271.svg";